// extracted by mini-css-extract-plugin
export default {"card":"style--card--c66123"};